import React, { createRef } from "react";
import { useExpanded, useSortBy, useTable } from "react-table";
import Request from './Request';

export  const postAccountsLog = (data, callback) => {
    const defaultData = {
      "estimate_id": 0,
      "customer_id": 0,
      "sales_amount": 0,
      "accounts_receivable_detail_id": 0,
      "receipt_amount": 0,
      "transaction_type": 0,
      "notes": "",
      "monthly_closing_flag": 0,
    }

    const postData = { ...defaultData, ...data };

    Request.post('/api/accounts/push', postData, res=>{
      if (callback) callback(res.data);
    })
}

